import React from 'react';
import HeroImg from '../../images/hero.svg';
import { AiOutlineTwitter } from 'react-icons/ai';

function Hero() {
  return (
    <>
      <section className="hero-sec">
        <div className="hero-sec-left">
          <p className="hero-heading">Learn things from fellow developers</p>
          <p className="hero-text">
            Learnist is an open platform for developers where they can learn new
            things simply by attending weekly sessions hosted by co-developers.
            Stimulate your career along with learning curve.
          </p>
          <p className="hero-text">
            We host weekly sessions on different technologies like Html, Css,
            Javascript, ReactJs, NodeJs, MongoDB, ExpressJs, Ruby, Ruby on
            Rails, GraphQL including Startups.
          </p>
          <a
            className="hero-text"
            href="https://twitter.com/thelearnist"
            target="_blank"
            rel="noopener noreferrer"
          >
            Want to join or host a session? Let's talk in DM{' '}
            <AiOutlineTwitter />
          </a>
        </div>
        <div className="hero-right-sec">
          <img src={HeroImg} alt="hero_image" />
        </div>
      </section>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="25.7"
        data-v-22168a6a=""
      >
        <path d="M1440 15.3s-64.6 9.5-156.4 10.2c-188.7 1.6-276.8-20.8-419.9-20.1s-202.9 14-290.8 13.4c-94.4-.7-194-13.3-331.9-13.3-137.3 0-156.8 8.2-241 9.8V0h1440v15.3z"></path>
      </svg>
    </>
  );
}

export default Hero;
